<template>
    <modal
        :show="show"
        body-classes="p-0"
        modal-classes="modal-sm"
        :container-classes="$style.container"
        @update:show="$emit('update:show', $event)"
    >
        <card class="mb-0 card-form">
            <template slot="header">
                <h2 class="modal-title">
                    Update Request #{{ deliveryRequest.id }}
                </h2>
            </template>
            <ValidationObserver v-slot="{ invalid, validate, pristine }">
                <form
                    ref="form"
                    class="mt-3"
                    autocomplete="off"
                    @submit.prevent="validate().then(submitUpdate)"
                >
                    <div class="row">
                        <div class="col-12">
                            <label>Status</label>
                            <div class="form-group">
                                <v-select
                                    v-model="update.status"
                                    :options="deliveryStatuses"
                                    placeholder="Select delivery status"
                                    label="label"
                                >
                                    <template slot="option" slot-scope="option">
                                        {{ option.label }}
                                    </template>
                                </v-select>
                            </div>
                        </div>
                        <div class="col-12 mt-2">
                            <el-checkbox
                                v-model="update.changeRequestReceived"
                                :disabled="
                                    deliveryRequest.changeRequestReceived ||
                                    deliveryRequest.changeRequestReceived ===
                                        null
                                "
                            />
                            <span class="ml-2">Change Request Received</span>
                        </div>
                    </div>
                    <div :class="$style.actions">
                        <base-button
                            type="default"
                            class="btn-fill"
                            @click="$emit('update:show', false)"
                        >
                            Cancel
                        </base-button>
                        <base-button
                            id="update"
                            :disabled="invalid || pristine"
                            native-type="submit"
                            type="primary"
                            class="btn-fill"
                        >
                            Update
                        </base-button>
                    </div>
                </form>
            </ValidationObserver>
        </card>
    </modal>
</template>

<script>
import { ValidationObserver } from "vee-validate";
import vSelect from "vue-select";
import { Modal } from "src/components/UI";
import { Checkbox } from "element-ui";

export default {
    name: "DeliveryRequestUpdateModal",
    components: {
        ValidationObserver,
        Modal,
        vSelect,
        [Checkbox.name]: Checkbox,
    },
    props: {
        deliveryRequest: {
            type: Object,
            required: true,
        },
        show: {
            type: Boolean,
            required: true,
        },
    },
    data() {
        return {
            deliveryStatuses: [
                "Submitted",
                "Pending",
                "Scheduled",
                "OnHold",
                "Cancelled",
                "Delivered",
            ],
            update: {},
        };
    },
    watch: {
        show: {
            immediate: true,
            handler(visible) {
                if (visible) this.update = {};
            },
        },
    },
    methods: {
        async submitUpdate() {
            this.update.id = this.deliveryRequest.id;
            this.update.customerID = this.deliveryRequest.customer.id;
            this.update.designerIDS =
                this.deliveryRequest.deliveryRequestDetails.map(
                    (i) => i.designer?.id,
                );
            this.$emit("updateDeliveryRequest", this.update);
            this.$refs.form.reset();
        },
    },
};
</script>

<style module lang="scss">
.container {
    z-index: 1090;
}
.actions {
    margin-top: 30px;
    display: flex;
    justify-content: space-between;
}
.actions .right > * {
    margin-right: 10px;
    margin-left: 10px;
}
</style>
